// Constantes partagées de l'espace admin Minds' Academy.

export const LEVELS = ['1A', '2A', '3A', '4A', '5A']

export const SUBJECTS = [
  'Mathématiques',
  'Physique',
  'Chimie',
  'Informatique',
  'Programmation C',
  'Algorithmique',
  'Biologie',
  'Économie',
  'Gestion',
  'Anglais',
  'Français',
  'Histoire-Géo',
  'Philosophie',
  'Autre',
]

export const LEVEL_OPTIONS = ['', ...LEVELS]
